import {
    CREATESYMPTOMSTYPE,
    GETSYMPTOMSTYPE,
    UPDATESYMPTOMSTYPE,
    DELETESYMPTOMSTYPE,
    CREATESYMPTOMSHEAD,
    GETSYMPTOMSHEAD,
    UPDATESYMPTOMSHEAD,
    DELETESYMPTOMSHEAD,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATESYMPTOMSTYPE:
            return {
                ...state,
                symptomstypeSaveStatus: action.payload.success,
            }
        case GETSYMPTOMSTYPE:
                return {
                        ...state,
                        symptomstypeList: action.payload.data,
                        }
        case UPDATESYMPTOMSTYPE:
                return {
                        ...state,
                        symptomstypeUpdateStatus: action.payload.success,
                        }   

        case DELETESYMPTOMSTYPE:
                 return {
                     ...state,
                     symptomstypeDeleteStatus: action.payload.success,
                        } 
        case CREATESYMPTOMSHEAD:
                return {
                        ...state,
                        symptomsheadSaveStatus: action.payload.success,
                        }
        case GETSYMPTOMSHEAD:
                 return {
                        ...state,
                        symptomsheadList: action.payload.data,
                        }
        case UPDATESYMPTOMSHEAD:
                return {
                        ...state,
                        symptomsheadUpdateStatus: action.payload.success,
                        }   
                
        case DELETESYMPTOMSHEAD:
                    return {
                            ...state,
                            symptomsheadDeleteStatus: action.payload.success,
                            } 
        default:
                return state
                      }
                 }